import React from 'react';
import { FiUser } from 'react-icons/fi';

const EmptyState = ({ mode, title }) => (
  <div className="empty-state">
    <FiUser size={48} style={{ color: '#666', marginBottom: '16px' }} />
    <h3>{title || `No ${mode || 'Player'} Stats Available`}</h3>
    <p>No player statistics found for the selected filters.</p>
    <p style={{ fontSize: '14px', color: '#888', marginTop: '8px' }}>
      Try adjusting your date range or filters to see more data.
    </p>
  </div>
);

export default EmptyState;

